module.exports = __webpack_public_path__ + "static/30-5bf64bb653b54b8d0b3271ff80224699.jpg";